import BlockGamerModal from '@features/games/settings/block-gamer/block-gamer';
export default BlockGamerModal;
